<div *ngIf="tiles?.length < 1" [ngClass]="styles.blankLayoutTile">
	<span>0</span>
</div>

<div [ngClass]="[
		styles.iconVideoTile,
		isFullFrame ? styles.iconFullFrame : ''
	]" *ngFor="let tile of tiles; index as index" [ngStyle]="tile">
	<span>{{index + 1}}</span>
</div>
